import { render } from "./BalanceDialog.vue?vue&type=template&id=3f256ede"
import script from "./BalanceDialog.vue?vue&type=script&lang=js"
export * from "./BalanceDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__